module.exports = {
  CopyMonthSetting: 'การตั้งค่า CopyMonth',
  FinanceSetting: 'การตั้งค่าข้อมูลทางการเงิน',
  HrSetting: 'การตั้งค่าข้อมูล HR',
  MonthlyDataArchive: 'การเก็บข้อมูลรายเดือน (Archive)',
  MonthlyFinance: 'วันที่กำหนดรายเดือน (การเงิน)',
  MonthlyHr: 'วันที่กำหนดรายเดือน (HR)',
  MonthDataArchive: 'การเก็บข้อมูลกลางเดือน (Archive)',
  WeeklyDay: 'ทุกสัปดาห์',
  SetJudgmentCriteria: 'ตั้งค่าเงื่อนไขการตรวจสอบความแตกต่าง',
  ExportingData: 'กำลังส่งออกข้อมูล...',
  ExportActualAmountData: 'ส่งออกข้อมูลการตัดบัญชี Accpac',
  ExportInvoiceData: 'ส่งออกข้อมูลใบแจ้งหนี้ Accpac',
  ExportBillingData: 'ส่งออกข้อมูลบัญชีต่างประเทศ Accpac',
  SelectDataWithInvoiceNumber: 'กรุณาเลือกข้อมูลที่มีหมายเลขใบแจ้งหนี้',
  SelectDataWithBillingNumber: 'กรุณาเลือกข้อมูลที่มีหมายเลขบัญชี'
}
